import { render, staticRenderFns } from "./IncomeLedger.vue?vue&type=template&id=5e02c225&"
import script from "./IncomeLedger.vue?vue&type=script&lang=js&"
export * from "./IncomeLedger.vue?vue&type=script&lang=js&"
import style0 from "./IncomeLedger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports